import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Center, Spinner } from '@chakra-ui/react';

// HomePage stays eager — it's almost always the entry point and is what
// react-snap pre-renders for `/`. Lazy-loading it would defeat first-paint.
import HomePage from './pages/HomePage';

// All other pages lazy-load. Each becomes its own JS chunk so the initial
// bundle only ships HomePage + shared chunks.
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const HowItWorksPage = lazy(() => import('./pages/HowItWorksPage'));
const InvestmentsPage = lazy(() => import('./pages/InvestmentsPage'));
const TeamPage = lazy(() => import('./pages/TeamPage'));
const CareersPage = lazy(() => import('./pages/CareersPage'));
const MarketInsightsPage = lazy(() => import('./pages/MarketInsightsPage'));
const GuidesPage = lazy(() => import('./pages/GuidesPage'));
const CalculatorPage = lazy(() => import('./pages/CalculatorPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const DisclaimerPage = lazy(() => import('./pages/DisclaimerPage'));
const CompliancePage = lazy(() => import('./pages/CompliancePage'));
const FAQPage = lazy(() => import('./pages/FAQPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage'));
const MarketplacePage = lazy(() => import('./pages/MarketplacePage'));
const UpdatesPage = lazy(() => import('./pages/UpdatesPage'));
const AdminChatPage = lazy(() => import('./pages/AdminChatPage'));
const AdminLoginPage = lazy(() => import('./pages/AdminLoginPage'));

const RouteFallback = () => (
  <Center minH="60vh">
    <Spinner size="xl" color="primary.500" thickness="4px" />
  </Center>
);

const Router = () => {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/investments" element={<InvestmentsPage />} />
        <Route path="/marketplace" element={<MarketplacePage />} />
        <Route path="/market-insights" element={<MarketInsightsPage />} />
        <Route path="/guides" element={<GuidesPage />} />
        <Route path="/calculator" element={<CalculatorPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="/compliance" element={<CompliancePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/updates" element={<UpdatesPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/chat" element={<AdminChatPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default Router;
